import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useTheme } from '../../contexts/ThemeContext';

export default function CustomCircularProgress({ color=undefined }) {
  const { theme } = useTheme();

  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress
        sx={{
          color: color ? color : theme.color.primary
        }}
      />
    </Box>
  );
}
